import { Phone, EnvelopeSimple, MapPin } from "@phosphor-icons/react";
import { SITE } from "@/constants/site";
import { FOOTER_COLUMNS } from "@/constants/footerLinks";
import { slug } from "@/constants/projects";

export default function Footer({ onEnquire }) {
  return (
    <footer data-testid="site-footer" className="grain bg-forest pb-28 pt-24 md:pb-24">
      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-12">
        <div className="flex items-center gap-4">
          <img
            src="/vr-logo.jpeg"
            alt="VR Ahmedabad Realtors logo"
            className="h-14 w-14 rounded-sm object-cover ring-1 ring-gold/50"
          />
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">Adani Shantigram · Ahmedabad</p>
        </div>
        <h2 className="mt-6 max-w-3xl font-serif text-3xl tracking-tight text-white sm:text-4xl lg:text-5xl">
          Your township address is one call away.
        </h2>
        <button
          data-testid="footer-enquire-btn"
          onClick={onEnquire}
          className="mt-10 rounded-sm bg-gold px-8 py-4 text-sm font-bold uppercase tracking-widest text-forest transition-colors duration-200 hover:bg-[#d4b274]"
        >
          Book a Private Viewing
        </button>
        <div className="mt-16 grid grid-cols-1 gap-8 border-t border-white/10 pt-10 sm:grid-cols-3">
          <div>
            <p className="text-xs uppercase tracking-widest text-white/40">Call</p>
            <a
              href={`tel:${SITE.phoneRaw}`}
              data-testid="footer-phone-link"
              className="mt-2 flex items-center gap-2 text-white transition-colors duration-200 hover:text-gold"
            >
              <Phone size={16} weight="fill" className="text-gold" /> {SITE.phoneDisplay}
            </a>
          </div>
          <div>
            <p className="text-xs uppercase tracking-widest text-white/40">Email</p>
            <a
              href={`mailto:${SITE.email}`}
              data-testid="footer-email-link"
              className="mt-2 flex items-center gap-2 text-white transition-colors duration-200 hover:text-gold"
            >
              <EnvelopeSimple size={16} weight="fill" className="text-gold" /> {SITE.email}
            </a>
          </div>
          <div>
            <p className="text-xs uppercase tracking-widest text-white/40">Visit</p>
            <p className="mt-2 flex items-center gap-2 text-white">
              <MapPin size={16} weight="fill" className="text-gold" /> SG Highway, Ahmedabad, Gujarat
            </p>
          </div>
        </div>
        <div className="mt-14 border-t border-white/10 pt-10">
          <div data-testid="popular-searches" className="grid grid-cols-2 gap-x-8 gap-y-8 md:grid-cols-4">
            {FOOTER_COLUMNS.map((col) => (
              <div key={col.title}>
                <p className="text-xs uppercase tracking-widest text-white/40">{col.title}</p>
                <div className="mt-3 flex flex-col gap-2">
                  {col.links.map((l) => (
                    <a
                      key={l.href}
                      href={l.href}
                      data-testid={`popular-search-${slug(l.label)}`}
                      className="text-xs text-white/50 transition-colors duration-200 hover:text-gold"
                    >
                      {l.label}
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        <p className="mt-14 text-xs leading-relaxed text-white/40">
          Disclaimer: VR Ahmedabad Realtors is an independent channel partner. This is not the official website of
          Adani Realty. Project names, images and details are indicative and belong to their respective developers.
          Prices and availability are subject to change — please verify all details with our team.
        </p>
        <p className="mt-4 text-xs text-white/40">© {new Date().getFullYear()} VR Ahmedabad Realtors. All rights reserved.</p>
      </div>
    </footer>
  );
}
